<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent value="" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ modalTitle }} Customer</span>
          <v-spacer></v-spacer>
          <v-btn text icon color="grey" @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <confirm-delete-in-modal
              v-if="showConfirmDelete"
              @confirmed="onConfirmDelete"
            ></confirm-delete-in-modal>
            <v-form ref="form" v-model="valid">
              <v-switch
                v-model="isBusiness"
                class="py-1"
                dense
                :label="isBusiness == true ? 'Is a Business' : 'Is a Person'"
              ></v-switch>
              <v-row>
                <v-col cols="12" sm="12" class="py-1" v-if="isBusiness">
                  <v-text-field
                    id="company-name"
                    label="Company Name"
                    v-model="companyNameValue"
                    class="py-1"
                    dense
                    required
                    :rules="[rules.required]"
                    v-on:keyup.enter="onSave"
                    autocomplete="none"
                    autofocus
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-1" v-if="!isBusiness">
                  <v-text-field
                    id="first-name"
                    label="First Name"
                    v-model="firstNameValue"
                    class="py-1"
                    dense
                    required
                    :rules="[rules.required]"
                    v-on:keyup.enter="onSave"
                    autocomplete="none"
                    autofocus
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-1" v-if="!isBusiness">
                  <v-text-field
                    id="last-name"
                    label="Last Name"
                    v-model="lastNameValue"
                    class="py-1"
                    dense
                    required
                    :rules="[rules.required]"
                    v-on:keyup.enter="onSave"
                    autocomplete="none"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="7" class="py-1" v-if="isAddNew">
                  <v-autocomplete
                    required
                    :rules="
                      requiredNewCustomerFields.includes('source')
                        ? [rules.required]
                        : []
                    "
                    v-model="sourceSelected"
                    class="py-1"
                    dense
                    :items="leadSources"
                    item-text="name"
                    item-value="id"
                    label="How did you hear about us?"
                    autocomplete="none"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  class="py-1"
                  v-if="sourceSelected && sourceSelected == -1 && isAddNew"
                >
                  <v-text-field
                    label="Other"
                    v-model="otherSourceValue"
                    class="py-1"
                    dense
                    hint="How did you hear about us?"
                    required
                    :rules="
                      requiredNewCustomerFields.includes('source')
                        ? [rules.required]
                        : []
                    "
                    v-on:keyup.enter="onSave"
                    autocomplete="none"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1 pt-2" v-if="isAddNew">
                  <v-autocomplete
                    required
                    :rules="
                      requiredNewCustomerFields.includes('phone')
                        ? [rules.required]
                        : []
                    "
                    v-model="phoneLabelValue"
                    :items="phoneLabels"
                    item-text="name"
                    item-value="id"
                    label="Phone Type"
                    dense
                    autocomplete="none"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col class="pt-2" cols="12" sm="12" v-if="isAddNew">
                  <v-text-field
                    id="contact-info-phone-number"
                    label="Phone Number"
                    v-model="phoneNumberValue"
                    class="py-1"
                    dense
                    required
                    :rules="
                      requiredNewCustomerFields.includes('phone')
                        ? [rules.required]
                        : []
                    "
                    persistent-hint
                    hint="e.g. (555) 555-1212"
                    v-mask="masks.phone"
                    v-on:keyup.enter="onSave"
                    autocomplete="none"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1 pt-2" cols="12" sm="4" v-if="isAddNew">
                  <v-autocomplete
                    required
                    :rules="
                      requiredNewCustomerFields.includes('address')
                        ? [rules.required]
                        : []
                    "
                    v-model="addressTypeValue"
                    :items="addressTypes"
                    item-text="name"
                    item-value="id"
                    label="Address Type"
                    dense
                    autocomplete="none"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col class="py-1" cols="12" v-if="isAddNew">
                  <v-text-field
                    label="Address 1"
                    v-model="address1Value"
                    required
                    :rules="
                      requiredNewCustomerFields.includes('address')
                        ? [rules.required]
                        : []
                    "
                    dense
                    autocomplete="none"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col class="py-1" cols="12" v-if="isAddNew">
                  <v-text-field
                    label="Address 2"
                    v-model="address2Value"
                    dense
                    autocomplete="none"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col class="py-1" cols="12" sm="5" v-if="isAddNew">
                  <v-text-field
                    label="City"
                    v-model="cityValue"
                    required
                    :rules="
                      requiredNewCustomerFields.includes('address')
                        ? [rules.required]
                        : []
                    "
                    dense
                    autocomplete="none"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col class="py-1" col="6" sm="4" v-if="isAddNew">
                  <v-autocomplete
                    required
                    :rules="
                      requiredNewCustomerFields.includes('address')
                        ? [rules.required]
                        : []
                    "
                    v-model="stateValue"
                    :items="states"
                    item-text="name"
                    item-value="id"
                    label="State"
                    dense
                    autocomplete="none"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col class="py-1" cols="6" sm="3" v-if="isAddNew">
                  <v-text-field
                    label="ZIP"
                    v-model="postalCodeValue"
                    required
                    :rules="
                      requiredNewCustomerFields.includes('address')
                        ? [rules.required, rules.zip]
                        : []
                    "
                    v-on:keyup.enter="onSave"
                    dense
                    autocomplete="none"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="showDelete" color="blue darken-1" text @click="onDelete"
            >Delete</v-btn
          >
          <v-btn color="primary tile" @click="onSave" class="mr-8 mb-8"
            >&nbsp;&nbsp;&nbsp;Save&nbsp;&nbsp;&nbsp;</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { VALIDATION_RULES } from "../../../helpers/ValidationRules";
import { STATES } from "../../../helpers/StaticLists";
import { MASKS } from "../../../helpers/Masks";
import { mask } from "vue-the-mask";
import { NEW_CUSTOMER_FIELDS } from "../../../globalVars";

const ConfirmDeleteInModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-ConfirmDeleteInModal" */ `./ConfirmDeleteInModal.vue`
  );

export default {
  name: "CustomerDetailFormModal",
  props: {
    CustomerId: Number,
    PhoneNumber: String,
    CustomerSource: Number,
    RerunReportCallback: Function,
    CallbackRecord: Object
  },
  components: {
    ConfirmDeleteInModal
  },
  directives: {
    mask
  },
  data: () => ({
    dialog: true,
    modalTitle: "Add",
    valid: true,
    showConfirmDelete: false,
    isBusiness: false,
    companyNameValue: null,
    firstNameValue: null,
    lastNameValue: null,
    sourceSelected: null,
    otherSourceValue: null,
    phoneLabelValue: "mobile",
    phoneNumberValue: null,
    addressTypeValue: "main",
    address1Value: null,
    address2Value: null,
    cityValue: null,
    stateValue: null,
    postalCodeValue: null,
    phoneLabels: [
      { id: "mobile", name: "Mobile" },
      { id: "home", name: "Home" },
      { id: "work", name: "Work" },
      { id: "other", name: "Other" }
    ],
    addressTypes: [
      { id: "main", name: "Main" },
      { id: "home", name: "Home" },
      { id: "office", name: "Office" },
      { id: "bill", name: "Billing" },
      { id: "ship", name: "Shipping" }
    ],
    states: STATES,
    masks: MASKS,
    rules: VALIDATION_RULES
  }),
  computed: {
    isAddNew() {
      return this.CustomerId == -1;
    },
    showDelete() {
      return !this.isAddNew && !this.showConfirmDelete;
    },
    currentCustomer() {
      let customer = this.$store.getters["entities/customers/find"](
        this.CustomerId
      );
      return customer;
    },
    user() {
      return this.$store.getters["entities/users/find"](
        this.$store.getters["entities/settings/query"]().first().userId
      );
    },
    leadSources() {
      let leadSources = this.$store.getters["entities/listTypes/query"]()
        .withAllRecursive(1)
        .where("code", value => ["lead_source"].includes(value))
        .first();
      if (leadSources && leadSources.items.length > 0) {
        leadSources.items.push({
          id: -1,
          name: "Other"
        });
        return leadSources.items;
      } else {
        return [];
      }
    },
    settings() {
      return this.$store.getters["entities/settings/query"]().first();
    },
    requiredNewCustomerFields() {
      if (
        this.settings &&
        this.settings.customerSettings &&
        this.settings.customerSettings.requiredNewCustomerFields
      ) {
        return this.settings.customerSettings.requiredNewCustomerFields;
      }
      return NEW_CUSTOMER_FIELDS.map(obj => obj.value);
    }
  },
  created() {
    if (
      this.CustomerId != null &&
      this.CustomerId > 0 &&
      this.currentCustomer
    ) {
      this.modalTitle = "Update";
      this.isBusiness = this.currentCustomer.isBusiness;
      if (this.isBusiness == true) {
        this.companyNameValue = this.currentCustomer.companyName;
      } else {
        this.firstNameValue = this.currentCustomer.firstName;
        this.lastNameValue = this.currentCustomer.lastName;
      }
    }
    if (this.PhoneNumber) {
      this.phoneNumberValue = this.PhoneNumber;
    }
    if (this.CustomerSource) {
      this.sourceSelected = this.CustomerSource;
    }
  },
  methods: {
    onClose() {
      this.$root.$children[0].showCustomerEditorModals = false;
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (this.isAddNew) {
          let vueThis = this;
          const tempId = this.$uuidv4();
          let newCustomerDetail = {
            id: tempId,
            tempId: tempId,
            isDirty: true,
            accountId: this.user.accountId,
            isBusiness: this.isBusiness,
            companyName: this.companyNameValue,
            firstName: this.firstNameValue,
            lastName: this.lastNameValue
          };
          if (this.sourceSelected) {
            newCustomerDetail.otherInfo = {
              isDirty: true,
              accountId: this.user.accountId,
              label: "Source",
              listItemId: this.sourceSelected,
              detail: this.otherSourceValue
            };
          }
          if (this.phoneNumberValue) {
            newCustomerDetail.contactInfo = {
              isDirty: true,
              accountId: this.user.accountId,
              type: "phone",
              label: this.phoneLabelValue,
              detail: this.phoneNumberValue,
              receiveNotification: true
            };
          }
          if (this.address1Value || this.cityValue) {
            newCustomerDetail.address = {
              isDirty: true,
              accountId: this.user.accountId,
              type: this.addressTypeValue,
              address1: this.address1Value,
              address2: this.address2Value,
              city: this.cityValue,
              state: this.stateValue,
              postalCode: this.postalCodeValue
            };
          }
          let callback = null;
          if (
            vueThis.RerunReportCallback != null &&
            vueThis.CallbackRecord != null
          ) {
            callback = function(customerId) {
              vueThis.RerunReportCallback(vueThis.CallbackRecord, customerId);
            };
          }
          this.$store.dispatch("entities/customers/createCustomer", {
            customer: newCustomerDetail,
            callback
          });
        } else if (this.CustomerId > 0) {
          this.$store.dispatch("entities/customers/updateCustomer", {
            accountId: this.user.accountId,
            id: this.CustomerId,
            isDirty: true,
            isBusiness: this.isBusiness,
            companyName: this.companyNameValue,
            firstName: this.firstNameValue,
            lastName: this.lastNameValue
          });
        }
        this.onClose();
      }
    },
    onDelete() {
      this.showConfirmDelete = true;
    },
    onConfirmDelete() {
      this.$store.dispatch("entities/customers/deleteCustomer", {
        accountId: this.user.accountId,
        id: this.CustomerId,
        isDirty: true
      });
      this.onClose();
    }
  }
};
</script>
<style scoped lang="stylus"></style>
